
export function RequiredInputValidator() {
  return (control: any): { [key: string]: any } | null => {
    if(control.nativeElement?.value===""){
      return { req: `Este campo es obligatorio` };
    }
    return null;
  };
}
